<template>
  <div
    class="flex size-[48px] cursor-pointer items-center justify-center rounded-full bg-collection transition-all duration-200 md:h-[58px] md:w-[273px] md:rounded-lg"
    @click="showModalAskQuestion"
  >
    <SvgIcon name="ask-question" class="!md:size-10 text-white !h-8 !w-8" />
    <span
      class="ml-2.5 hidden whitespace-nowrap text-[18px] uppercase leading-[22px] text-white-100 md:inline-block"
      >Спросить историка</span
    >
  </div>
</template>

<script setup>
const authStore = useAuthStore();
const modalsStore = useModalsStore();

const showModalAskQuestion = () => {
  if (!authStore.isAuthorized) {
    modalsStore.showSocialAuthForm();
    return;
  }
  modalsStore.showAskQuestion();
};
</script>
